export default __webpack_public_path__ + "static/media/productslide-3.db6e4b31.jpg";